import Vue from 'vue'
import App from './AppScoresNCAAFStatistics.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
